import {jwtDecode} from 'jwt-decode';

export function decodeJwtPayload<T>(token: string): null | T {
  try {
    return jwtDecode<T>(token);
  } catch {
    return null;
  }
}
